import { useTranslation } from "react-i18next";

const getPills = (t: (key: string) => string) => [
  t("pillRegistration"),
  t("pillCompliance"),
  t("pillInvestment"),
  t("pillExpansion"),
  t("pillTender"),
];

export default function ServicesHero() {
  const { t } = useTranslation();
  const pills = getPills(t);

  return (
    <section id="page-hero" className="relative pt-32 pb-20 bg-[#f8fafc] overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#0A1628] via-[#0A1628]/50 to-transparent" />
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-80 h-80 rounded-full bg-[#0A1628]/8 blur-3xl pointer-events-none" />

      <div className="w-full px-6 lg:px-12 relative z-10">
        <div className="max-w-3xl">
          <p className="text-[#00C2C2] text-xs font-semibold tracking-widest uppercase mb-4">{t("servicesHeroTag")}</p>
          <h1 className="text-5xl lg:text-6xl font-bold text-[#0A1628] leading-tight mb-6">
            {t("servicesHeroTitle1")}<br />
            <span className="italic font-light text-[#00C2C2]">{t("servicesHeroTitle2")}</span>
          </h1>
          <p className="text-gray-600 text-lg leading-relaxed max-w-2xl">
            {t("servicesHeroDesc")}
          </p>
        </div>
        <div className="flex flex-wrap gap-3 mt-10">
          {pills.map((label, i) => (
            <a
              key={label}
              href={`#service-${i + 1}`}
              className="bg-white border border-gray-200 text-[#0A1628] text-sm font-semibold px-4 py-2 rounded-full hover:bg-[#0A1628] hover:text-white hover:border-[#0A1628] transition-all whitespace-nowrap cursor-pointer"
            >
              {label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
